import axios, { AxiosInstance } from 'axios';
import React from 'react';
import { useCookies } from 'react-cookie';

export type TrackFn = (events: any, email?: any) => Promise<void>;

export const useTrackApi = (provider: string, tenant: string, enabled: boolean) => {
	const API_URL = process.env.REACT_APP_API_URL;

	const [userViewerId, setUserViewerId] = React.useState();
	const [userViewerEmail, setUserViewerEmail] = React.useState();
	const [pendingTrackingEvents, setPendingTrackingEvents] = React.useState([]);
	const [cookies, setCookie] = useCookies();

	const trackApiConfig = React.useMemo(
		() => ({
			baseURL: `${API_URL}`
		}),
		[API_URL]
	);

	const _ajax: AxiosInstance = React.useMemo(() => axios.create({ ...trackApiConfig }), [trackApiConfig]);

	React.useEffect(() => {
		if (userViewerId) {
			pendingTrackingEvents.forEach(pendingEvents => {
				_ajax.post(`${provider}EventTracker`, {
					userViewerId,
					userViewerEmail,
					events: pendingEvents
				});
			});
		}
		if (userViewerEmail) {
			if (!cookies[`${provider}-${tenant}`] || !cookies[`${provider}-${tenant}`].userViewerEmail) setEmailIntoCookie(userViewerEmail);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userViewerId]);

	React.useEffect(() => {
		if (cookies[`${provider}-${tenant}`] && cookies[`${provider}-${tenant}`].userViewerId && !userViewerId)
			setUserViewerId(cookies[`${provider}-${tenant}`].userViewerId);
		if (cookies[`${provider}-${tenant}`] && cookies[`${provider}-${tenant}`].userViewerEmail && !userViewerEmail)
			setUserViewerEmail(cookies[`${provider}-${tenant}`].userViewerEmail);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cookies]);

	const setEmailIntoCookie = email => {
		setUserViewerEmail(email);
		setCookie(`${provider}-${tenant}`, { userViewerId, userViewerEmail: email });
	};

	const track = React.useCallback(
		async (events, email?) => {
			if (!enabled || process.env.NODE_ENV === 'development') return;

			if ((!cookies[`${provider}-${tenant}`] || !cookies[`${provider}-${tenant}`].userViewerEmail) && !!email) setEmailIntoCookie(email);
			else if (cookies[`${provider}-${tenant}`] && cookies[`${provider}-${tenant}`].userViewerEmail && !userViewerEmail)
				setUserViewerEmail(cookies[`${provider}-${tenant}`].userViewerEmail);

			if (!userViewerId) return setPendingTrackingEvents(currentPendingTrackingEvents => [...currentPendingTrackingEvents, events]);

			_ajax.post(`${provider}EventTracker`, {
				userViewerId,
				userViewerEmail: email ? email : userViewerEmail,
				events
			});
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[_ajax, enabled, userViewerId]
	);

	return { track };
};
